export default __webpack_public_path__ + "static/media/regulatory--end-of-shared-path-pedestrians-and-bicycles--g1.04370a0f.png";